<script setup lang="ts">
import { $t } from '@/composables/translations/useTranslate';

interface Props {
  /** Number of insurance-row placeholders to render. */
  count?: number;
}

withDefaults(defineProps<Props>(), {
  count: 2,
});
</script>

<template>
  <div class="animate-pulse" aria-hidden="true">
    <span class="sr-only">{{ $t('ibe.common.loading', 'Loading...') }}</span>
    <div
      v-for="i in count"
      :key="`insurance-skeleton-${i}`"
      class="flex flex-col py-5 lg:flex-row"
      :class="{ 'border-t border-gray-200': i > 1 }"
    >
      <!-- Left: title + description -->
      <div class="flex-1">
        <div class="h-5 bg-actions-tertiary rounded w-1/2 mb-2.5"></div>
        <div class="space-y-2">
          <div class="h-4 bg-actions-tertiary rounded w-full"></div>
          <div class="h-4 bg-actions-tertiary rounded w-3/4"></div>
        </div>
      </div>

      <!-- Right: availability + price + button -->
      <div
        class="flex flex-col items-start gap-2.5 mt-6 mb-4 lg:items-end lg:w-1/3 lg:mt-0 lg:mb-0"
      >
        <div class="flex items-center gap-1.5">
          <div class="w-2.5 h-2.5 rounded-full bg-actions-tertiary"></div>
          <div class="h-4 bg-actions-tertiary rounded w-20"></div>
        </div>
        <div class="h-7 bg-actions-tertiary rounded w-24"></div>
        <div class="h-12 bg-actions-tertiary rounded w-full lg:w-40 mt-2.5"></div>
      </div>
    </div>
  </div>
</template>
